<template>
  <div>
    <div class="sm:fe-hidden">
      <JdsDialog @close="$emit('close')">
        <template #header>
          <div class="fe-text-heading-xxs lg:fe-text-heading-xs">
            Ask a question
          </div>
        </template>

        <template #body>
          <div class="fe-h-[1px] fe-bg-primary-grey-40 fe-mb-m fe-mt-s"></div>
          <div
            class="fe-flex fe-justify-between fe-items-center fe-text-body-s fe-text-primary-grey-60"
          >
            <div>Your question will be reviewed and posted in 1-2 days.</div>
            <div>{{ questionHelperText }}</div>
          </div>
          <div>
            <JdsTextArea
              placeholder="Type your question here.."
              :required="true"
              :min-length="questionConfig?.content?.minCharLimit"
              :max-length="questionConfig?.content?.maxCharLimit"
              :value="questionText"
              @input="handleQuestionText"
              :state="questionTextError ? 'error' : 'none'"
              :state-text="questionTextError"
              textAreaClassname="fe-min-h-[96px]"
            />
          </div>
        </template>

        <template #footer>
          <div>
            <JdsButton
              size="medium"
              variant="primary"
              :fullWidth="true"
              :disabled="!!questionTextError || !questionText"
              @click="handleSubmit"
            >
              Submit
            </JdsButton>
          </div>
        </template>
      </JdsDialog>
    </div>

    <div class="lg:fe-hidden">
      <JdsSidePanel @close="$emit('close')">
        <template #header>
          <div>Ask a question</div>
        </template>

        <template #body>
          <div class="fe-flex fe-flex-col fe-items-center fe-mt-xxl">
            <div>
              <svg
                width="134"
                height="134"
                viewBox="0 0 134 134"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.509766"
                  width="133.418"
                  height="133.418"
                  rx="66.709"
                  fill="#E5F1F7"
                />
                <mask
                  id="mask0_109_30707"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="134"
                  height="134"
                >
                  <rect
                    x="0.509766"
                    width="133.418"
                    height="133.418"
                    rx="66.709"
                    fill="#E5F1F7"
                  />
                </mask>
                <g mask="url(#mask0_109_30707)">
                  <path
                    d="M123.014 133.672H70.803L67.3083 126.191C64.9932 122.562 61.8588 119.539 58.1622 117.369C56.038 116.122 54.1873 114.452 52.7227 112.46C51.2581 110.468 50.2103 108.196 49.6429 105.782C49.496 105.174 49.5353 104.535 49.7555 103.951C49.9757 103.366 50.3665 102.862 50.8763 102.506L67.0522 91.2792C67.5592 90.9249 68.1611 90.7351 68.7776 90.7349H81.9206C82.7209 90.7349 83.4888 90.4156 84.0569 89.8465C84.625 89.2775 84.9473 88.5048 84.9535 87.6969L85.0176 82.0699C85.0176 81.199 86.5206 79.3041 86.7025 79.0081C89.2384 74.454 90.0185 69.1147 88.893 64.0154L87.0935 55.888C87.0766 55.8029 87.0598 55.7213 87.0497 55.6362C86.5913 52.3737 86.2678 47.5598 88.5527 43.0827C89.5637 41.1198 91.9799 39.4222 94.0659 38.7656L94.1569 38.7418C94.4475 38.6509 94.7544 38.6254 95.0558 38.6673C95.3572 38.7092 95.6458 38.8173 95.9013 38.984C96.1568 39.1508 96.3729 39.3721 96.5344 39.6324C96.6959 39.8927 96.7989 40.1856 96.8361 40.4904L97.6786 47.485C97.9758 49.8209 98.5892 52.1045 99.5017 54.272C99.5354 54.3502 99.5691 54.4251 99.6062 54.4965L104.402 64.1379C107.07 69.537 108.227 75.5691 107.748 81.5834L106.889 92.4325C105.231 100.288 114.552 118.611 123.014 133.672Z"
                    fill="#FF9DA3"
                  />
                  <path
                    d="M38.9748 54.7371L27.8896 48.337C25.3647 46.8793 22.1361 47.7443 20.6784 50.2693L20.5517 50.4887C19.0939 53.0136 19.959 56.2422 22.4839 57.6999L33.5691 64.1C36.094 65.5577 39.3226 64.6927 40.7804 62.1677L40.9071 61.9483C42.3648 59.4234 41.4997 56.1948 38.9748 54.7371Z"
                    fill="#FF9DA3"
                  />
                  <path
                    d="M78.5321 20.3026H42.3115C37.4715 20.3026 33.5479 24.2262 33.5479 29.0662V104.933C33.5479 109.773 37.4715 113.697 42.3115 113.697H78.5321C83.3721 113.697 87.2957 109.773 87.2957 104.933V29.0662C87.2957 24.2262 83.3721 20.3026 78.5321 20.3026Z"
                    fill="#0C5273"
                  />
                  <path
                    d="M83.0225 40.3425V95.7841C83.0143 96.2101 82.8384 96.6156 82.533 96.9125C82.2275 97.2095 81.8173 97.374 81.3913 97.3703H39.4474C39.0214 97.3749 38.611 97.2106 38.3059 96.9133C38.0009 96.6161 37.826 96.2101 37.8196 95.7841V38.7286C37.8388 35.9531 38.9556 33.298 40.926 31.3432C42.8965 29.3884 45.5604 28.2928 48.3359 28.2956H70.8749C74.0793 28.2955 77.1539 29.5615 79.4292 31.8179C81.7044 34.0743 82.996 37.1383 83.0225 40.3425Z"
                    fill="white"
                  />
                  <path
                    d="M54.708 24.902H66.1268C66.6999 24.902 67.1646 24.4374 67.1646 23.8643V23.8122C67.1646 23.2391 66.6999 22.7745 66.1268 22.7745H54.708C54.1349 22.7745 53.6703 23.2391 53.6703 23.8122V23.8643C53.6703 24.4374 54.1349 24.902 54.708 24.902Z"
                    fill="#0C5273"
                  />
                  <path
                    d="M60.4667 109.216C62.2724 109.216 63.7362 107.752 63.7362 105.946C63.7362 104.141 62.2724 102.677 60.4667 102.677C58.661 102.677 57.1973 104.141 57.1973 105.946C57.1973 107.752 58.661 109.216 60.4667 109.216Z"
                    fill="#67C3EF"
                  />
                  <path
                    d="M44.0415 69.6794L35.2888 64.6261C32.7639 63.1683 29.5353 64.0334 28.0775 66.5583L27.9508 66.7777C26.4931 69.3026 27.3582 72.5312 29.8831 73.9889L38.6358 79.0423C41.1607 80.5001 44.3893 79.635 45.8471 77.1101L45.9738 76.8906C47.4315 74.3657 46.5665 71.1372 44.0415 69.6794Z"
                    fill="#FF9DA3"
                  />
                  <path
                    d="M44.0415 81.8606L35.2888 76.8072C32.7639 75.3495 29.5353 76.2146 28.0775 78.7395L27.9509 78.9589C26.4931 81.4838 27.3582 84.7123 29.8831 86.1701L38.6358 91.2235C41.1608 92.6812 44.3893 91.8161 45.8471 89.2912L45.9738 89.0718C47.4315 86.5469 46.5664 83.3183 44.0415 81.8606Z"
                    fill="#FF9DA3"
                  />
                  <path
                    d="M39.8539 91.7231L35.748 89.3526C33.2231 87.8949 29.9945 88.76 28.5368 91.2849L28.4101 91.5043C26.9523 94.0292 27.8174 97.2578 30.3423 98.7155L34.4482 101.086C36.9731 102.544 40.2017 101.679 41.6594 99.1538L41.7861 98.9344C43.2439 96.4095 42.3788 93.1809 39.8539 91.7231Z"
                    fill="#FF9DA3"
                  />
                  <path
                    d="M46.1082 39.9059C46.0673 41.7506 45.3057 43.506 43.9866 44.7962C42.6675 46.0864 40.8956 46.8088 39.0504 46.8088C37.2052 46.8088 35.4334 46.0864 34.1143 44.7962C32.7951 43.506 32.0336 41.7506 31.9927 39.9059H46.1082Z"
                    fill="#E30513"
                  />
                  <path
                    d="M46.2461 38.4926L46.1003 39.8809C46.1007 39.4143 46.1495 38.949 46.2461 38.4926Z"
                    fill="#E30513"
                  />
                  <path
                    d="M60.2124 39.9059C60.2124 41.7773 59.469 43.572 58.1457 44.8952C56.8225 46.2185 55.0277 46.9619 53.1564 46.9619C51.285 46.9619 49.4903 46.2185 48.167 44.8952C46.8437 43.572 46.1003 41.7773 46.1003 39.9059H60.2124Z"
                    fill="#FC6770"
                  />
                  <path
                    d="M74.3277 39.9059C74.2868 41.7506 73.5252 43.506 72.2061 44.7962C70.8869 46.0864 69.1151 46.8088 67.2699 46.8088C65.4247 46.8088 63.6529 46.0864 62.3337 44.7962C61.0146 43.506 60.2531 41.7506 60.2122 39.9059H74.3277Z"
                    fill="#E30513"
                  />
                  <path
                    d="M88.4509 39.9059C88.4509 41.7773 87.7075 43.572 86.3842 44.8952C85.061 46.2185 83.2662 46.9619 81.3949 46.9619C79.5235 46.9619 77.7288 46.2185 76.4055 44.8952C75.0823 43.572 74.3389 41.7773 74.3389 39.9059H88.4509Z"
                    fill="#FC6770"
                  />
                  <path
                    d="M88.4509 39.9059L88.3052 38.5176C88.4001 38.9743 88.4489 39.4394 88.4509 39.9059Z"
                    fill="#E30513"
                  />
                  <path
                    d="M47.4128 27.2963L46.2466 38.4929C46.15 38.9494 46.1012 39.4147 46.1009 39.8812H31.9854L32.2942 37.8509L33.9151 27.272L47.4128 27.2963Z"
                    fill="#E30513"
                  />
                  <path
                    d="M46.1077 39.9059C46.108 39.4393 46.1569 38.974 46.2534 38.5176L46.1077 39.9059Z"
                    fill="#E30513"
                  />
                  <path
                    d="M74.3277 27.2963H60.2122V39.9055H74.3277V27.2963Z"
                    fill="#E30513"
                  />
                  <path
                    d="M88.4509 39.9059L88.3052 38.5176C88.4001 38.9743 88.4489 39.4394 88.4509 39.9059Z"
                    fill="#E30513"
                  />
                  <path
                    d="M60.2127 27.2963V39.9055H46.0972L46.2464 38.4999L47.4126 27.2963H60.2127Z"
                    fill="#FC6770"
                  />
                  <path
                    d="M88.4409 39.9055H74.3289V27.2963H87.1255L88.2951 38.4999L88.4409 39.9055Z"
                    fill="#FC6770"
                  />
                </g>
                <line
                  opacity="0.5"
                  x1="86.8703"
                  y1="18.9361"
                  x2="91.2347"
                  y2="13.6365"
                  stroke="#FF9DA3"
                  stroke-width="2.90039"
                  stroke-linecap="round"
                />
                <line
                  opacity="0.5"
                  x1="81.9964"
                  y1="16.5735"
                  x2="83.25"
                  y2="11.2317"
                  stroke="#FF9DA3"
                  stroke-width="2.90039"
                  stroke-linecap="round"
                />
                <line
                  opacity="0.5"
                  x1="89.7398"
                  y1="23.1248"
                  x2="95.4927"
                  y2="21.1411"
                  stroke="#FF9DA3"
                  stroke-width="2.90039"
                  stroke-linecap="round"
                />
                <path
                  d="M61.1262 53.1562C53.4062 53.1562 47.1262 59.4363 47.1262 67.1562C47.1262 74.8763 53.4062 81.1562 61.1262 81.1562C68.8462 81.1562 75.1262 74.8763 75.1262 67.1562C75.1262 59.4363 68.8462 53.1562 61.1262 53.1562ZM62.0396 72.3263C62.0396 72.8629 61.6062 73.3029 61.0762 73.3029H61.0029C60.4729 73.3029 60.0396 72.8662 60.0396 72.3263V72.2796C60.0396 71.7429 60.4729 71.3029 61.0029 71.3029H61.0762C61.6062 71.3029 62.0396 71.7396 62.0396 72.2796V72.3263ZM63.7462 66.7096C63.2929 67.2163 62.7496 67.6496 62.3596 68.2096C62.1562 68.5029 62.1429 68.4563 62.0162 68.7996C61.9129 69.0796 61.9762 69.4663 61.8296 69.7396C61.5929 70.1796 61.1029 70.3096 60.6362 70.1129C60.0896 69.8796 60.0062 69.3296 60.0429 68.7996C60.0829 68.1963 60.1762 67.9396 60.4762 67.4029C60.7629 66.8929 61.1862 66.4829 61.5896 66.0696C62.2696 65.3729 63.2962 64.1562 62.1862 63.3129C61.2096 62.5696 59.8829 63.1196 59.6196 64.2662C59.4996 64.7896 59.3262 65.2429 58.8029 65.4163C58.4129 65.5463 57.9962 65.4529 57.7529 65.1196C57.1129 64.2429 57.9362 62.6729 58.5862 62.0263C60.2496 60.3696 63.5729 60.7763 64.4729 63.0496C64.4696 63.0429 64.4662 63.0329 64.4629 63.0263C64.4396 62.9729 64.4296 62.9396 64.4262 62.9296C64.4296 62.9429 64.4462 62.9829 64.4629 63.0263C64.4662 63.0363 64.4696 63.0396 64.4729 63.0496C64.4996 63.1196 64.5129 63.1529 64.5162 63.1629C64.5096 63.1463 64.4929 63.0996 64.4729 63.0529C64.9996 64.3696 64.6696 65.6796 63.7462 66.7096Z"
                  fill="#F06D0F"
                />
              </svg>
            </div>
            <div class="fe-text-heading-xxs fe-mt-base">
              Ask a question about the product
            </div>
          </div>
        </template>

        <template #footer>
          <div>
            <div
              class="fe-flex fe-justify-between fe-items-center fe-text-body-xxs fe-text-primary-grey-60 fe-mb-xs"
            >
              <div>Your question will be reviewed and posted in 1-2 days.</div>
            </div>
            <div class="fe-flex fe-items-end fe-justify-between fe-gap-s">
              <div class="fe-shrink-0 fe-grow">
                <JdsTextArea
                  placeholder="Type your question here.."
                  :required="true"
                  :min-length="questionConfig?.content?.minCharLimit"
                  :max-length="questionConfig?.content?.maxCharLimit"
                  :value="questionText"
                  @input="handleQuestionText"
                  :state="questionTextError ? 'error' : 'none'"
                  :state-text="questionTextError"
                  textAreaClassname="fe-rounded-medium fe-min-h-[96px]"
                />
              </div>
              <div class="fe-shrink-0">
                <JdsButton
                  variant="primary"
                  size="small"
                  :iconOnly="true"
                  :disabled="!!questionTextError"
                  @click="handleSubmit"
                >
                  <template #icon>
                    <JdsIcon
                      name="SendMessageIcon"
                      size="m"
                      color="fe-text-white"
                    />
                  </template>
                </JdsButton>
              </div>
            </div>
          </div>
        </template>
      </JdsSidePanel>
    </div>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import JdsDialog from "@/components/DesignSystem/JdsDialog/JdsDialog.vue"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"
  import JdsSidePanel from "@/components/DesignSystem/JdsSidePanel/JdsSidePanel.vue"
  import JdsTextArea from "@/components/DesignSystem/JdsTextArea/JdsTextArea.two.vue"
  import { modalMixin } from "@/mixins/modalMixin"
  import { toastMixin } from "@/mixins/toastMixin"
  import { apiAddQuestion } from "@/api_service/qnaApi"

  export default {
    name: "AskQuestionCta",
    components: {
      JdsButton,
      JdsDialog,
      JdsTextArea,
      JdsSidePanel,
      JdsIcon,
    },
    mixins: [modalMixin, toastMixin],
    inject: ["globalState"],
    data() {
      return {
        questionText: "",
        questionTextError: "",
        loading: false,
      }
    },
    watch: {
      questionText() {
        if (this.questionTextError) {
          if (this.validateQuestionText()) {
            this.questionTextError = ""
          }
        }
      },
    },
    computed: {
      questionConfig() {
        return this.globalState.widgetConfig?.question_properties
      },
      questionHelperText() {
        const maxCharLength = this.questionConfig?.content?.maxCharLimit
        return `${this.questionText.length}/${maxCharLength}`
      },
      productData() {
        return this.globalState.product
      },
    },
    methods: {
      handleQuestionText(questionText) {
        this.questionText = questionText
      },
      validateQuestionText() {
        const config = this.questionConfig?.content

        const charLength = this.questionText.length

        const { minCharLimit = 0, maxCharLimit = 0 } = config

        // If content is hidden, then no need to check for validity
        // If content string is empty and it is not required (as per config), then no need to check for validity
        if (config.hidden || (!config.required && !charLength)) {
          return true
        }

        // If content is filled by user, then it doesn't matter, if it is required or not, it should met min and max character guideline
        if (
          charLength &&
          charLength >= minCharLimit &&
          charLength <= maxCharLimit
        ) {
          return true
        }

        const errorMessages = {
          contentError: "Please provide your question",
          minError: `Minimum ${minCharLimit} characters required`,
          maxError: `Maximum ${minCharLimit} characters required`,
        }

        if (!charLength) {
          this.questionTextError = errorMessages.contentError
        } else if (charLength < minCharLimit) {
          this.questionTextError = errorMessages.minError
        } else if (charLength > maxCharLimit) {
          this.questionTextError = errorMessages.maxError
        }

        return false
      },
      async handleSubmit() {
        try {
          this.loading = true

          if (!this.validateQuestionText()) {
            this.loading = false
            return
          }

          const requestData = {
            productId: this.productData.productId,
            productURL: this.productData.productURL,
            alternateCode1: this.productData.alternateCode1,
            alternateCode2: this.productData.alternateCode2,
            categoryL1: this.productData.categoryL1,
            categoryL2: this.productData.categoryL2,
            categoryL3: this.productData.categoryL3,
            categoryL4: this.productData.categoryL4,
            question: this.questionText.trim(),
          }

          const response = await apiAddQuestion(requestData)

          this.loading = false

          this.$emit("close")
          this.showToast("Question Submitted", "success")

          return response?.data
        } catch (error) {
          this.loading = false
          this.showToast(error?.message, "error")
        }
      },
    },
  }
</script>
